import { render, staticRenderFns } from "./FileVersionMetadata.vue?vue&type=template&id=0aa7793d&"
import script from "./FileVersionMetadata.vue?vue&type=script&lang=js&"
export * from "./FileVersionMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports